import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { Accordion, AccordionDetails, Box, Grid, CircularProgress, Backdrop } from "@mui/material";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import { AddData } from "src/app-redux/common-actions";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import CommonButton from "src/components/CommonButton/CommonButton";
import CommonButtonOutLined from "src/components/CommonButton/CommonButtonOutLined";
import CommonDrawer from "src/components/CommonDrawer/CommonDrawer";
import CommonTextEditor from "src/components/CommonTextEditor/CommonTextEditor";
import NoRecordFound from "src/components/NoRecordFound";
import { Card } from "./Card";
import Heading from "./Heading";
import { useStyles } from "./styles";

type Props = {
  expand: boolean;
  updateExpandStatus: (type: number) => void;
};

export function Notes({ expand, updateExpandStatus }: Props): React.ReactElement {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [loader, setLoader] = useState(false);
  const [notesData, setNotesData] = useState({});
  const [note, setNote] = useState<string>("");
  const [isOpenDilog, setIsOpenDilog] = useState<boolean>(false);
  const { ordNum } = useParams<{ ordNum: any }>();

  const getNotesData = async () => {
    try {
      setLoader(true);
      const { venderNotes } = await fetchWrapper.get(
        "get-vendor-notes-by-vendor-num-vendor-portal"
      );
      if (venderNotes) {
        setNotesData(venderNotes);
      }

      return setLoader(false);
    } catch (error: any) {
      setLoader(false);
      dispatch(
        addNotificationAction({
          message: error.message,
          options: { variant: "error" },
        })
      );
    }
  };
  const addNotes = async () => {
    setLoader(true);
    const body = {
      vendNum: 0,
      currentUser: 0,
      noteType: "Other",
      notes: note,
      webDisplay: true,
    };
    try {
      await dispatch(
        AddData("/create-vendor-notes-by-vendor", "Note added successfully", JSON.stringify(body))
      );
    } catch (error) {
      setLoader(false);
    }
    setIsOpenDilog(false);
    getNotesData();
    setLoader(false);
  };
  useEffect(() => {
    if (expand) {
      getNotesData();
    }
  }, [expand]);
  return (
    <>
      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box border={1} mb={2} borderColor="grey.200">
        <Accordion square elevation={0} expanded={expand} onChange={() => updateExpandStatus(3)}>
          <Heading heading="Notes" />
          <Box borderTop={1} mb={1} borderColor="grey.200"></Box>
          <AccordionDetails>
            <Grid container direction="row">
              <Grid xs={12} md={12}>
                {Boolean(Object.keys(notesData).length) ? (
                  Object.values(notesData).map((item, i) => (
                    <Card key={i} index={i} RowData={item} />
                  ))
                ) : (
                  <NoRecordFound />
                )}
                <Grid item xs={12}>
                  <Box component="span">
                    <CommonButtonOutLined
                      isGreen
                      onClick={() => {
                        setIsOpenDilog(true);
                        setNote("");
                      }}
                    >
                      Add New Note
                    </CommonButtonOutLined>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Box>
      <Grid container direction="row">
        <CommonDrawer
          heading={"Note Information"}
          isOpen={isOpenDilog}
          closeDrawer={() => {
            setIsOpenDilog(false);
          }}
        >
          <Grid item xs={12} md={12}>
            <CommonTextEditor
              value={note}
              onChange={(v: any) => {
                setNote(v.target.value);
              }}
              name={"comment"}
              height={240}
              title="Comment"
              required
              showHeader
            />
          </Grid>

          <Grid item xs={12}>
            <Box mt={2} mb={2} textAlign="right">
              <Box component="span" mr={2}>
                <CommonButton
                  onClick={() => {
                    setIsOpenDilog(false);
                  }}
                >
                  Cancel
                </CommonButton>
              </Box>
              <Box component="span">
                <CommonButton
                  isGreen
                  disable={!note}
                  onClick={() => {
                    addNotes();
                  }}
                >
                  Save
                </CommonButton>
              </Box>
            </Box>
          </Grid>
        </CommonDrawer>
      </Grid>
    </>
  );
}
